import React from "react";
import { Switch, Route } from "react-router-dom";
import { PageLayout } from "../../components/PageLayout";
import { CreateDynoPage } from "../CreateDynoPage";
import { MyDynosPage } from "../MyDynosPage";
import { ClassesPage } from "../ClassesPage";
import { EditorPage } from "../EditorPage";
import { ViewerPage } from "../ViewerPage";
import { ProfilePage } from "../ProfilePage";
import { SubmissionsPage } from "../SubmissionsPage";

export const MainPage = ({ user, userRole }) => {
  const navListItems =
    userRole !== "Student"
      ? [
          { name: "My Dynos", link: `/` },
          { name: "Create New Dyno", link: `/createdyno` },
        ]
      : [];
  return (
    <PageLayout user={user} userRole={userRole} navListItems={navListItems}>
      <Switch>
        {userRole === "Student" ? (
          <>
            <Route exact path="/class/:id">
              <ClassesPage user={user} userRole={userRole} />
            </Route>
            <Route exact path="/viewer/:id/:classId">
              <ViewerPage />
            </Route>
            <Route exact path="/profile">
              <ProfilePage user={user} userRole={userRole} />
            </Route>
            <Route exact path="/submission/:id">
              <SubmissionsPage user={user} userRole={userRole} />
            </Route>
          </>
        ) : (
          <>
            <Route exact path="/">
              <MyDynosPage user={user} userRole={userRole} />
            </Route>
            <Route exact path="/createdyno">
              <CreateDynoPage />
            </Route>
            <Route exact path="/class/:id">
              <ClassesPage user={user} userRole={userRole} />
            </Route>
            <Route exact path="/editor/:id">
              <EditorPage />
            </Route>
            <Route exact path="/viewer/:id/:classId?">
              <ViewerPage />
            </Route>
            <Route exact path="/submission/:id">
              <SubmissionsPage user={user} userRole={userRole} />
            </Route>
            <Route exact path="/profile">
              <ProfilePage user={user} userRole={userRole} />
            </Route>
          </>
        )}
      </Switch>
    </PageLayout>
  );
};
